import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { Button } from './charte/Button';

const RETRY_KEY = 'permio:module-reload-at';
const RETRY_INTERVAL = 5 * 60 * 1000;

function isModuleLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : '';
  return /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS/i.test(message);
}

/** Loaded eagerly: this page must remain available when a route chunk is missing. */
export function RouteErrorPage() {
  const error = useRouteError();
  const moduleError = isModuleLoadError(error);
  useEffect(() => {
    if (!moduleError || !navigator.onLine) return;
    try {
      const now = Date.now();
      const previous = Number(sessionStorage.getItem(RETRY_KEY));
      if (previous && now - previous < RETRY_INTERVAL) return;
      // Persist BEFORE reloading, including under StrictMode. Fail closed if
      // storage is unavailable, otherwise an unavailable asset could loop.
      sessionStorage.setItem(RETRY_KEY, String(now));
      window.location.reload();
    } catch {
      // Manual recovery remains available when storage is disabled.
    }
  }, [moduleError]);

  return (
    <main className="charte-root min-h-screen bg-surface-light p-8 font-sans text-body">
      <section className="mx-auto mt-16 max-w-lg rounded-2xl bg-white p-8 shadow-card" role="alert">
        <h1 className="text-xl font-semibold text-heading">
          {moduleError ? 'Impossible de charger cette page' : 'Cette page a rencontré une erreur'}
        </h1>
        <p className="my-4 text-sm text-secondary">
          {moduleError
            ? 'Une mise à jour ou une interruption de connexion peut être en cause. Vérifiez votre connexion, puis rechargez la page.'
            : 'Vous pouvez recharger la page pour réessayer.'}
        </p>
        <p className="mb-4 text-sm text-secondary">Les modifications non enregistrées peuvent être perdues.</p>
        <Button variant="primary" onClick={() => window.location.reload()}>Recharger la page</Button>
      </section>
    </main>
  );
}
